"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sovramonte": {
    "3faaa1f2": [{
      "hkey": "9264f715",
      "slug": "passo-croce-d-aune",
      "name": "Passo Croce d'Aune",
      "primary": true,
      "skipSearch": false
    }],
    "croce-d-aune": [{
      "hkey": "9264f715",
      "slug": "passo-croce-d-aune",
      "name": "Passo Croce d'Aune",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "741da68d": [{
      "hkey": "ff8f7371",
      "slug": "sorriva-campagna",
      "name": "Sorriva-Campagna",
      "primary": true,
      "skipSearch": false
    }],
    "sorriva": [{
      "hkey": "ff8f7371",
      "slug": "sorriva-campagna",
      "name": "Sorriva-Campagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;